import {createApp} from "vue";
import PasswordGenerator from "@components/helpers/PasswordGenerator.vue";

createApp(PasswordGenerator).mount('#password-generator')
